import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";

import BasicDetails from "./BasicDetails";
import SystemInformation from "./SystemInformation";
import UserDetails from "./UserDetails";
import GoogleReview from "./GoogleReview";

import ConsumerPerception from "./ConsumerPerception";
import MMTR from "./MTTR";
import { Typography } from "@mui/material";
import ChatDetails from "./ChatDetails";
import { getDateTime } from "../../../../utils/data";

interface Iprops {
  topic: string;
  feedbackData: any;
}

const EmailDetails = (props: Iprops) => {
  const renderDetails = (details: { [key: string]: any }) => {
    return (
      <>
        {Object.keys(details).map((detailsKey) =>
          typeof details[detailsKey] === "object" ? (
            Object.keys(details[detailsKey]).map((key: string) => (
              <>
                {details[detailsKey][key] && (
                  <Grid item xs={12} md={6}>
                    <Typography className="title-sm-fb">
                      {key === "family" ? "OS" : key}
                    </Typography>
                    <Typography className="info reportstickets">
                      {details[detailsKey][key] || ""}
                    </Typography>
                  </Grid>
                )}
              </>
            ))
          ) : (
            <>
              {details[detailsKey] && (
                <Grid item xs={12} md={6}>
                  <Typography className="title-sm-fb">{detailsKey}</Typography>
                  <Typography className="info reportstickets">
                    {details[detailsKey] || ""}
                  </Typography>
                </Grid>
              )}
            </>
          )
        )}
      </>
    );
  };

  const renderChat = (chat: any) => {
    return (
      <>
        <Grid item xs={12} md={12}>
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <div style={{ display: "flex", maxWidth: "420px" }}>
              <Typography
                className="title-sm-fb"
                style={{ lineHeight: "18px" }}
              >
                Human:{" "}
              </Typography>
              <Typography className="info reportstickets">
                {chat["human"]}{" "}
              </Typography>
            </div>
            <Typography style={{ fontSize: "10px" }}>
              {getDateTime(chat["startTime"])}{" "}
            </Typography>{" "}
          </div>
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <div style={{ display: "flex", maxWidth: "420px" }}>
              <Typography
                className="title-sm-fb"
                style={{ lineHeight: "18px" }}
              >
                Chatbot:{" "}
              </Typography>
              <Typography className="info reportstickets">
                {chat["chatbot"]}{" "}
              </Typography>
            </div>
            <Typography style={{ fontSize: "10px" }}>
              {getDateTime(chat["endTime"])}{" "}
            </Typography>{" "}
          </div>
        </Grid>
      </>
    );
  };

  const renderChatDetails = (details: any) => {
    if (details && details.chats && details.chats.length > 0) {
      return (
        <>
          {details.chats.map((chat: any) => {
            return renderChat(chat);
          })}
        </>
      );
    }
    return <></>;
  };

  return (
    <Box sx={{ padding: "15px 30px" }}>
      <Grid container justifyContent="space-between">
        <Grid md={6} xs={12}>
          <BasicDetails feedbackData={props.feedbackData} />
          <UserDetails
            feedbackData={props.feedbackData}
            renderDetails={renderDetails}
          />
          <SystemInformation
            feedbackData={props.feedbackData}
            renderDetails={renderDetails}
          />
          {props.feedbackData.feedbackComments &&
            Object.keys(props.feedbackData.feedbackComments).length > 0 &&
            props.feedbackData.feedbackComments.chats && (
              <>
                <GoogleReview
                  productId={props.feedbackData.productId}
                  productVersion={props.feedbackData.productVersion}
                  topic={props.topic}
                />
              </>
            )}
        </Grid>
        <Grid md={5.8} xs={12}>
          {props.feedbackData.feedbackComments &&
            Object.keys(props.feedbackData.feedbackComments).length > 0 &&
            !props.feedbackData.feedbackComments.chats && (
              <>
                <GoogleReview
                  productId={props.feedbackData.productId}
                  productVersion={props.feedbackData.productVersion}
                  topic={props.topic}
                />
              </>
            )}

          <ChatDetails
            feedbackData={props.feedbackData}
            renderDetails={renderDetails}
            renderChatDetails={renderChatDetails}
          />
          {/* <ConsumerPerception />
          <MMTR /> */}
        </Grid>
      </Grid>
    </Box>
  );
};

export default EmailDetails;
